export enum KeywordsModeEnum {
  GROWTH = 'growth',
  POPULARITY = 'popularity',
}

export enum CategoryModeEnum {
  CATEGORY = 'category',
}

export const KeywordsCategoryModeEnum = {
  ...KeywordsModeEnum,
  ...CategoryModeEnum,
}

export type KeywordsCategoryModeEnum = KeywordsModeEnum | CategoryModeEnum
